var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorTriangleRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2368 1.04968L0.339065 18.1918C0.160277 18.5013 0.0661342 18.8525 0.0661011 19.21C0.066068 19.5675 0.160146 19.9187 0.338876 20.2283C0.517607 20.5379 0.774691 20.795 1.08428 20.9737C1.39388 21.1524 1.74507 21.2465 2.10255 21.2465H21.8964C22.2539 21.2465 22.6051 21.1524 22.9147 20.9737C23.2243 20.795 23.4813 20.5379 23.6601 20.2283C23.8388 19.9187 23.9329 19.5675 23.9328 19.21C23.9328 18.8525 23.8387 18.5013 23.6599 18.1918L13.7632 1.04968C13.5845 0.740174 13.3275 0.483161 13.018 0.304471C12.7085 0.12578 12.3574 0.0317078 12 0.0317078C11.6426 0.0317078 11.2915 0.12578 10.982 0.304471C10.6725 0.483161 10.4155 0.740174 10.2368 1.04968Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1291 6.33667H11.8709C11.2353 6.33667 10.72 6.85197 10.72 7.48762V12.989C10.72 13.6246 11.2353 14.1399 11.8709 14.1399H12.1291C12.7648 14.1399 13.2801 13.6246 13.2801 12.989V7.48762C13.2801 6.85197 12.7648 6.33667 12.1291 6.33667Z",
    fill: "#EF554F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.5031C12.707 18.5031 13.2801 17.93 13.2801 17.223C13.2801 16.5161 12.707 15.943 12 15.943C11.2931 15.943 10.72 16.5161 10.72 17.223C10.72 17.93 11.2931 18.5031 12 18.5031Z",
    fill: "#EF554F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTriangleRounded);
export default __webpack_public_path__ + "static/media/error-triangle-rounded.f38f03602254f5e70867274fa77a3d4e.svg";
export { ForwardRef as ReactComponent };